module.exports = __webpack_public_path__ + "assets/2b709795287f9f78ea037d376bd477d5.png";